import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import { userActions } from "../../../redux/actions/user";
import { alertsActions } from "../../../redux/actions/alertsActions";
import "../../../style/subAdmin/SubAdmin.scss";
import isEmpty from "lodash.isempty";

import Header from "../../frontend/Header/Header";
import Footer from "../../frontend/Footer/Footer";

import languageConfig from "../../../config/languageConfig";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const history = createBrowserHistory();
class ResetPassword extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      path: ["Home", "Login", "Reset Password"],
      alertMessage: "",
      msgType: "",
      email: "",
      password: "",
      confirmPassword: "",
      tokenData: {},
      token: "",
      show: false,
      disabled: "",
      hover: false,
      multi_lang: 'no',
      lang: '',
      default_lang: 'en',
      //default_lang: (cookies.get('default_lang') ? cookies.get('default_lang') : 'en'),
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
  }

  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }

  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });    
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
    this.setState({ disabled: false });
  }

  validate = () => {
    let isError = false;
    if (this.state.password && this.state.confirmPassword) {
      if (this.state.password != this.state.confirmPassword) {
        this.setState({
          confirmPasswordError: languageConfig[this.state.default_lang].password_match
        });
      } else {
        this.setState({ confirmPasswordError: "" });
      }
    }
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();

    const err = this.validate();
    if (!err) {
      this.setState({ disabled: true });
      let postData = {
        email: this.state.email,
        password: this.state.confirmPassword,
        token: this.state.token,
        lang: this.state.default_lang,
      };
      this.props.dispatch(userActions.reset_Passsword(postData));
    }
  }

  Clear() {
    (this.state.confirmPassword = ""), (this.state.password = "");
  }

  componentDidMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    let disableSubscriptionPopup = (localStorage.getItem('disableSubscriptionPopup')) ? localStorage.getItem('disableSubscriptionPopup') : false;
    let accessibleCities = (localStorage.getItem('accessibleCities')) ? JSON.parse(localStorage.getItem('accessibleCities')) : [];

    // alert("Footer default_lang"+siteData.default_lang);
    // alert("Footer multi_lang"+siteData.multi_lang);
    // alert("Footer lang"+siteData.lang);

    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){
        this.setState({
    multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
  
        });
      }
    }
  }

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: siteData.default_lang,
        });
      }
    }
    this.props.dispatch(alertsActions.clearAlerts());
    let tokenIdParams = this.props.match.params.token
      ? this.props.match.params.token
      : "";

    if (tokenIdParams !== "") {
      this.props.dispatch(userActions.getLoginDetailByToken(tokenIdParams));
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.language){
      this.setState({default_lang: nextProps.language});
    }

    if(nextProps.themeData){
      if(nextProps.themeData.button){
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }
    if (
      this.props.resetResponse !== nextProps.resetResponse &&
      !isEmpty(nextProps.resetResponse)
    ) {
      this.setState({ disabled: false });
      this.props.dispatch(alertsActions.clearAlerts());
      this.handleShow();
      this.props.dispatch(
        alertsActions.renderAlerts(
          "success",
          languageConfig[this.state.default_lang].update_password
        )
      );
      this.Clear();
    }
    if (this.props.tokenDetail !== nextProps.tokenDetail) {
      if (!isEmpty(nextProps.tokenDetail)) {
        this.setState({
          tokenData: nextProps.tokenDetail,
          email: nextProps.tokenDetail.data.email,
          token: nextProps.tokenDetail.data.token
        });
      }
    }
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.setState({ disabled: false });
        this.props.dispatch(alertsActions.clearAlerts());
        this.props.dispatch(
          alertsActions.renderAlerts("warning", nextProps.error)
        );
      }
    }
    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  render() {
    return (
      <div>
        <div className="container">
          <div className="col-lg-12 add-sub-admin">
            <div className="row">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{(this.state.msgType == 'success') ? languageConfig[this.state.default_lang].success : languageConfig[this.state.default_lang].warning}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              {(this.props.match.params.token == "") &&
              <div className="col-xs-12">
                <BreadcrumbComponent path={this.state.path} />
              </div>
              }
            </div>
            <div className="panel">
              <header className="panel-heading">{languageConfig[this.state.default_lang].reset_password}</header>

              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <form onSubmit={this.handleSubmit}>
                      <Col xs={12}>
                        <FormGroup controlId="formBasicUserNameText">
                          <ControlLabel>Email Address</ControlLabel>
                          <FormControl
                            type="email"
                            name="email"
                            value={this.state.email}
                            placeholder={languageConfig[this.state.default_lang].enter_email}
                            onChange={this.handleChange.bind(this)}
                            required="required"
                            disabled={true}
                          />
                        </FormGroup>
                        <FormGroup controlId="formBasicUserNameText">
                          <ControlLabel>{languageConfig[this.state.default_lang].password}</ControlLabel>
                          <FormControl
                            type="password"
                            name="password"
                            value={this.state.password}
                            placeholder={languageConfig[this.state.default_lang].password}
                            onChange={this.handleChange.bind(this)}
                            required="required"
                          />
                        </FormGroup>
                        <FormGroup controlId="formBasicUserNameText">
                          <ControlLabel>{languageConfig[this.state.default_lang].confirm_password}</ControlLabel>
                          <FormControl
                            type="password"
                            name="confirmPassword"
                            value={this.state.confirmPassword}
                            placeholder={languageConfig[this.state.default_lang].confirm_password}
                            onChange={this.handleChange.bind(this)}
                            required="required"
                          />
                          <p className="inline-validation-error">
                            {this.state.confirmPasswordError !== ""
                              ? this.state.confirmPasswordError
                              : " "}
                          </p>
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <Button
                          bsStyle="success"
                          style={{backgroundColor: (this.state.hover && this.state.hoverID == 'Reset') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                          data-id = {'Reset'}
                          onMouseEnter={this.hoverOn} 
                          onMouseLeave={this.hoverOff}
                          type="submit"
                          disabled={this.state.disabled}
                        >
                          {languageConfig[this.state.default_lang].submit}
                        </Button>
                        <Button
                          bsStyle="default"
                          onClick={() => this.context.router.history.push(`/login`)}
                        >
                          {languageConfig[this.state.default_lang].cancel}
                        </Button>
                      </Col>
                    </form>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    tokenDetail: state.user.tokenDetail,
    resetResponse: state.user.resetResponse,
    error: state.user.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message
  };
};
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps)
)(ResetPassword);



// WEBPACK FOOTER //
// ./src/app/views/admin/resetPassword/ResetPassword.js